import { useRef } from "react";
import { Calendar } from "lucide-react";

export default function DateField({ value, onChange, testId, max, className = "" }) {
  const ref = useRef(null);
  return (
    <div className="relative">
      <input
        ref={ref}
        type="date"
        value={value || ""}
        max={max}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
        className={`w-full px-2.5 py-2 pr-9 rounded-md bg-slate-950 border border-slate-800 text-sm [color-scheme:dark] [&::-webkit-calendar-picker-indicator]:opacity-0 ${className}`}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => {
          const el = ref.current;
          if (!el) return;
          try {
            if (el.showPicker) el.showPicker();
            else el.focus();
          } catch {
            el.focus();
          }
        }}
        data-testid={testId ? `${testId}-cal` : undefined}
        title="Open calendar"
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-200 transition-colors"
      >
        <Calendar className="h-4 w-4" />
      </button>
    </div>
  );
}
